import { IBestbets } from './IBestbets';
import { BestbetsMapper } from './mapper';

/**
 * iterate through the bestbets result response and crate a model with help of mapper class
 * @param   {array} data search api response
 */
export class BestbetsModel {
  bestbetsData: Array<IBestbets> = [];

  constructor(bestbetsData: any = []) {
    if (bestbetsData) {
      const transModel = new BestbetsMapper(bestbetsData);
      this.bestbetsData.push(transModel.bestbetsUser);
    }
  }
}
